export default __webpack_public_path__ + "388b1681930ab8bb4949fc130a2fbc8c573cd079e7e914151f137a2fedfb63f2.png";